import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./HeroSection.css";

const slides = [
  {
    title: "We Build Your Dream Projects",
    desc: "High-quality construction solutions for residential & commercial buildings.",
    btnText: "Get Started",
    btnTarget: "contact",
    bg: "https://i.pinimg.com/1200x/48/0f/7e/480f7e0844debdee24e9994f122fcdf1.jpg",
  },
  {
    title: "Modern & Sustainable Design",
    desc: "Innovative architecture with long-lasting materials.",
    btnText: "View Projects",
    btnTarget: "projects",
    bg: "https://i.pinimg.com/736x/3d/00/81/3d0081254077632ed2e18180ee0997da.jpg",
  },
  {
    title: "Trusted Construction Partner",
    desc: "Delivering excellence with safety and precision.",
    btnText: "Contact Us",
    btnTarget: "contact",
    bg: "https://i.pinimg.com/1200x/d7/bb/b5/d7bbb5c43039678e8a1b64cf907b5efa.jpg",
  },
];

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (!section) return;

    window.scrollTo({
      top: section.offsetTop - window.innerHeight * 0.03,
      behavior: "smooth",
    });

    section.classList.add("section-animate");
    setTimeout(() => section.classList.remove("section-animate"), 600);
  };

  return (
    <section className="hero" id="hero">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          className="hero-slide"
          style={{ backgroundImage: `url(${slides[index].bg})` }}
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        />
      </AnimatePresence>

      {/* Overlay */}
      <div className="overlay"></div>

      {/* Content */}
      <motion.div
        className="hero-content"
        key={slides[index].title}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1>{slides[index].title}</h1>
        <p>{slides[index].desc}</p>
        <button
          className="hero-btn"
          onClick={() => scrollToSection(slides[index].btnTarget)}
        >
          {slides[index].btnText}
        </button>
      </motion.div>
    </section>
  );
}
